import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDocFromServer } from 'firebase/firestore';
import firebaseConfig from '../../firebase-applet-config.json';

// Inicialização segura do Firebase App
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

// Instâncias exportadas
export const db = getFirestore(app, firebaseConfig.firestoreDatabaseId);
export const auth = getAuth(app);
export { app };

/**
 * Validação de conectividade com o Firestore
 */
export async function testFirestoreConnection(): Promise<boolean> {
  try {
    await getDocFromServer(doc(db, 'test', 'connection'));
    return true;
  } catch (error) {
    if (error instanceof Error && error.message.includes('the client is offline')) {
      console.warn('Firebase Firestore: Cliente offline ou configuração pendente.');
      return false;
    }
    // Documento inexistente é normal para teste de conectividade
    return true;
  }
}
